export default __webpack_public_path__ + "static/media/bill.8ce14928.jpg";